/**
 * Provider dropdown options for the workflow builder's model pickers.
 *
 * Shared by the sub-agent override panels and the node model-slot pickers
 * (ModelChoicePicker) so both list the same providers the same way.  The
 * user's keys come from `buildConfiguredProviderOptions`, the list every
 * provider dropdown shows (utils/providerOptions), re-exported here.
 */
export { buildConfiguredProviderOptions } from '../../utils/providerOptions';

/** The platform's own models, always available (Stackform holds the keys). */
export const STACKFORM_PROVIDER_OPTION = {
  value: 'stackform',
  label: 'Stackform (built-in)',
  provider: 'stackform',
  configIndex: 1,
};
